import { format, parseISO, addHours, getHours, Locale } from 'date-fns';
import { formatInTimeZone, utcToZonedTime } from 'date-fns-tz';
import { ptBR as pt, enUS as en, es } from 'date-fns/locale';

const locales: Record<string, Locale> = {
  ptBr: pt,
  en: en,
  es: es,
};


export const fullDate = (dateValue: string | Date, language = 'ptBr'): string => {
  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);
    const zonedDate = utcToZonedTime(parsedDate, 'America/Sao_Paulo');


    formattedDate = format(zonedDate, "dd 'de' MMMM 'de' yyyy", {
      locale: pt,
    });

  } catch (err) {

    return '';
  }

  formattedDate = formattedDate.replace('março', 'Março');
  formattedDate = formattedDate.replace('abril', 'Abril');
  formattedDate = formattedDate.replace('maio', 'Maio');
  formattedDate = formattedDate.replace('junho', 'Junho');
  formattedDate = formattedDate.replace('julho', 'Julho');
  formattedDate = formattedDate.replace('agosto', 'Agosto');
  formattedDate = formattedDate.replace('setembro', 'Setembro');
  formattedDate = formattedDate.replace('outubro', 'Outubro');
  formattedDate = formattedDate.replace('novembro', 'Novembro');
  formattedDate = formattedDate.replace('dezembro', 'Dezembro');
  formattedDate = formattedDate.replace('janeiro', 'Janeiro');
  formattedDate = formattedDate.replace('fevereiro', 'Fevereiro');

  formattedDate = formattedDate.replace('segunda', 'Segunda');
  formattedDate = formattedDate.replace('terça', 'Terça');
  formattedDate = formattedDate.replace('quarta', 'Quarta');
  formattedDate = formattedDate.replace('quinta', 'Quinta');
  formattedDate = formattedDate.replace('sexta', 'Sexta');
  formattedDate = formattedDate.replace('sábado', 'Sábado');
  formattedDate = formattedDate.replace('domingo', 'Domingo');

  return formattedDate;
};

export const toGMT3 = (date) => {
  const localOffset = date.getTimezoneOffset(); // Obtém o offset local em minutos
  const gmt3Offset = -3 * 60; // Offset para GMT -3 em minutos
  const offsetDiff = gmt3Offset - localOffset; // Diferença entre o fuso atual e GMT -3
  return new Date(date.getTime() + offsetDiff * 60 * 1000); // Ajusta a data
};

export const dateSimpleBR = (dateValue: string): string => {
  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);
    formattedDate = formatInTimeZone(parsedDate, 'America/Sao_Paulo', 'dd/MM/yyyy');

  } catch (err) {

    return '';
  }
  return formattedDate;
};

export const dateSimpleEN = (dateValue: string): string => {
  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);
    formattedDate = formatInTimeZone(parsedDate, 'America/Sao_Paulo', 'yyyy-MM-dd');

  } catch (err) {

    return '';
  }
  return formattedDate;
};

export const checkIsAfterDate = (currentDate: string | Date, compareToDate = new Date()) => {
  try {
    const fromDate = typeof currentDate === 'object' ? toGMT3(new Date(currentDate)) : typeof currentDate === 'string' ? toGMT3(new Date(currentDate)) : toGMT3(currentDate);
    const toDate = typeof compareToDate === 'object' ? toGMT3(new Date(compareToDate)) : typeof compareToDate === 'string' ? toGMT3(new Date(compareToDate)) : toGMT3(compareToDate);

    return fromDate > toDate;
  }
  catch (err) {

    return false;
  }

}

export const dateLanguageTime = (dateValue: string | Date, language = 'ptBr'): string => {
  if (!dateValue) return '';
 
  try {
    const parsedDate = typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);
    const locale = locales[language] || pt;

    const formatStr = language === 'en' ? 'hh:mm aaaa' : language === 'es' ? 'HH:mm' : "HH'h'mm";

    let date = formatInTimeZone(parsedDate, 'America/Sao_Paulo', formatStr, { locale });

    if(language === 'ptBr' && date?.indexOf('h00') >= 0){
      date = date?.replace('h00','h');
    }

    return date;



  } catch (err) {
    console.error(err);
    return '';
  }
};

export const dateLanguageDate = (dateValue: string | Date, language = 'ptBr'): string => {
  if (!dateValue) return '';

  try {
    const parsedDate = typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);
    const locale = locales[language] || pt;

    const formatStr =
      language === 'ptBr'
        ? "dd 'de' MMMM 'de' yyyy"
        : language === 'es'
        ? "dd 'de' MMMM 'de' yyyy"
        : 'MMMM dd, yyyy';

    return formatInTimeZone(parsedDate, 'America/Sao_Paulo', formatStr, { locale });
  } catch (err) {
    console.error(err);
    return '';
  }
};
export const dateFullWithHour = (dateValue: string | Date, language = 'ptBr'): string => {

  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);
    formattedDate = formatInTimeZone(parsedDate, 'America/Sao_Paulo', "dd 'de' MMMM 'de' yyyy 'as' HH'h'mm ");




    console.log(formattedDate);
  } catch (err) {
    console.log(err);
    return '';
  }

  formattedDate = formattedDate.replace('março', 'Março');
  formattedDate = formattedDate.replace('abril', 'Abril');
  formattedDate = formattedDate.replace('maio', 'Maio');
  formattedDate = formattedDate.replace('junho', 'Junho');
  formattedDate = formattedDate.replace('julho', 'Julho');
  formattedDate = formattedDate.replace('agosto', 'Agosto');
  formattedDate = formattedDate.replace('setembro', 'Setembro');
  formattedDate = formattedDate.replace('outubro', 'Outubro');
  formattedDate = formattedDate.replace('novembro', 'Novembro');
  formattedDate = formattedDate.replace('dezembro', 'Dezembro');
  formattedDate = formattedDate.replace('janeiro', 'Janeiro');
  formattedDate = formattedDate.replace('fevereiro', 'Fevereiro');

  formattedDate = formattedDate.replace('segunda', 'Segunda');
  formattedDate = formattedDate.replace('terça', 'Terça');
  formattedDate = formattedDate.replace('quarta', 'Quarta');
  formattedDate = formattedDate.replace('quinta', 'Quinta');
  formattedDate = formattedDate.replace('sexta', 'Sexta');
  formattedDate = formattedDate.replace('sábado', 'Sábado');
  formattedDate = formattedDate.replace('domingo', 'Domingo');

  return formattedDate;
};


export const date = (dateValue: string): string => {
  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);

    formattedDate = formatInTimeZone(dateValue, 'America/Sao_Paulo', 'dd/MM/yyyy');

  } catch (err) {
    return '';
  }
  return formattedDate;
};

export const dateWithHour = (dateValue: string): string => {
  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);

    formattedDate = formatInTimeZone(dateValue, 'America/Sao_Paulo', "dd/MM/yyyy HH'h'mm");

  } catch (err) {
    return '';
  }
  return formattedDate;
};

export const simpleDotDate = (dateValue: string, language = 'ptBr'): string => {
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);
    formattedDate = formatInTimeZone(parsedDate, 'America/Sao_Paulo', language === 'en' ? 'MM.dd' : 'dd.MM');

  } catch (err) {
    return '';
  }
  return formattedDate;
};

export const dateSimple = (dateValue: string): string => {
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);
    const formattedDate = formatInTimeZone(parsedDate, 'America/Sao_Paulo', 'dd/MM');

  } catch (err) {
    return '';
  }
  return formattedDate;
};

export const hour = (dateValue: string, language = 'ptBr'): string => {
  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);


    formattedDate = formatInTimeZone(parsedDate, 'America/Sao_Paulo', "HH'h'mm");


    formattedDate = formattedDate.replace('h00', 'h');
  } catch (err) {
    return '';
  }
  return formattedDate;
};

export const day = (dateValue: string): string => {
  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);


    formattedDate = formatInTimeZone(parsedDate, 'America/Sao_Paulo', "dd");

  } catch (err) {
    return '';
  }
  return formattedDate;
};

export const year = (dateValue: string | Date): string => {
  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);


    formattedDate = formatInTimeZone(parsedDate, 'America/Sao_Paulo', "Y");

  } catch (err) {
    return '';
  }
  return formattedDate;
};

export const dateSimpleBRWithHour = (dateValue: string): string => {
  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);
    formattedDate = formatInTimeZone(parsedDate, 'America/Sao_Paulo', "dd/MM/yyyy HH'h'mm");

  } catch (err) {

    return '';
  }
  return formattedDate;
};


export const monthNumber = (dateValue: string | Date): string => {
  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);


    formattedDate = formatInTimeZone(parsedDate, 'America/Sao_Paulo', "MM");

  } catch (err) {
    return '';
  }
  return formattedDate;
};

export const month = (dateValue: string | Date): string => {
  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);


    formattedDate = formatInTimeZone(parsedDate, 'America/Sao_Paulo', "LLL");

  } catch (err) {
    return '';
  }
  return formattedDate;
};

export const monthFull = (dateValue: string | Date): string => {
  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);


    formattedDate = formatInTimeZone(parsedDate, 'America/Sao_Paulo', "LLLL");

  } catch (err) {
    return '';
  }
  return formattedDate;
};


export const dateLanguageHour = (dateValue: string | Date, language = 'ptBr'): string => {
  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);
    formattedDate = formatInTimeZone(parsedDate, 'America/Sao_Paulo', language === 'en' ? "HH'h'mm - ' EEEE" : language === 'es' ? "HH'h'mm '-' EEEE" : "HH'h'mm '-' EEEE");

  } catch (err) {
    return '';
  }



  return formattedDate;
};

const localeMap: Record<string, Locale> = {
  ptBr: pt,
  en: en,
  es: es,
};

const maskMap: Record<string, string> = {
  ptBr: "dd 'de' MMMM - EEEE",
  es: "dd 'de' MMMM - EEEE",
  en: 'MMMM, dd - EEEE',
};

 
export const dateLanguage = (
  dateValue: string | Date,
  language  = 'ptBr'
): string => {
  if (!dateValue) return '';

  const d = dateValue instanceof Date ? dateValue : parseISO(dateValue);
  if (isNaN(d.getTime())) return '';

  try {
    let out = formatInTimeZone(
      d,
      'America/Sao_Paulo',
      maskMap[language],
      { locale: localeMap[language] }
    );

 

    return out;
  } catch {
    return '';
  }
};
export const simpleDate = (dateValue: string): string => {
  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);
    formattedDate = formatInTimeZone(parsedDate, 'America/Sao_Paulo', "dd'.'MM");

  } catch (err) {
    return '';
  }
  return formattedDate;
};

export const simpleDateUS = (dateValue: string): string => {
  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);
    formattedDate = formatInTimeZone(parsedDate, 'America/Sao_Paulo', "yyyy'-'MM-dd");

  } catch (err) {
    return '';
  }
  return formattedDate;
};


export const simpleDateBR = (dateValue: string): string => {
  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);
    formattedDate = formatInTimeZone(parsedDate, 'America/Sao_Paulo', "dd'/'MM'/'yyyy");

  } catch (err) {
    return '';
  }
  return formattedDate;
};


export const simpleDateBRWithHour = (dateValue: string): string => {
  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);
    formattedDate = formatInTimeZone(parsedDate, 'America/Sao_Paulo', "dd'/'MM'/'yyyy HH'h'mm");

  } catch (err) {
    return '';
  }
  return formattedDate;
};

export const simpleDateUSWithHour = (dateValue: string): string => {
  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);
    formattedDate = formatInTimeZone(parsedDate, 'America/Sao_Paulo', "yyyy'-'MM-dd HH:mm");

  } catch (err) {
    return '';
  }
  return formattedDate;
};

export const simpleDateBRHour = (dateValue: string): string => {
  if (!dateValue) {
    return '';
  }
  let formattedDate = '';
  try {
    const parsedDate =
      typeof dateValue === 'object' ? new Date(dateValue) : parseISO(dateValue);
    formattedDate = formatInTimeZone(parsedDate, 'America/Sao_Paulo', "HH");

  } catch (err) {
    return '';
  }
  return formattedDate;
};
